// utils/userSettings.js

import { authFetch } from './api';
import { alertC } from  './../components/dialogService';
//import { alertC } from './alerts';
import { getCookie } from './cookies';

export const fetchUserField = async (fieldName, setter) => {
  const userId = getCookie('user_id') || 0;

  if (userId == 0) {
    const message = `User not logged in. Cannot fetch '${fieldName}'.`;
    alertC?.(message);
    console.error(message);
    return null;
  }

  try {
    const result = await authFetch(`/users/${userId}/field/${fieldName}`, {}, 'GET');
    if (result?.value !== undefined) {
      if (setter) setter(result.value);
      return result.value;
    } else {
      console.warn(`No value found for ${fieldName}`);
      return null;
    }
  } catch (err) {
    alertC?.(`Error fetching ${fieldName}: ${err}`);
    console.error(`Error fetching ${fieldName}:`, err);
    return null;
  }
};
